import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

export const routing = defineRouting({
  locales: ["de", "en", "fr", "nl", "it", "pl", "es", "cs", "zh", "da", "sv", "hu", "el", "tr", "fi", "no", "pt"],
  defaultLocale: "de",
  localePrefix: { mode: "as-needed" },
  // Auto-redirect first-time visitors to their browser language (Accept-Language).
  // The NEXT_LOCALE cookie takes priority once set, so the redirect only fires on
  // the first visit; an explicit switcher choice then sticks.
  localeDetection: true,
});

export type Locale = (typeof routing.locales)[number];

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
